import { FormFieldType } from '@wdx/shared/swagger-gen';
import { TransactionDetailCellField } from '../models';

export const TRANSACTION_DETAIL_FIELDS: {
    field: TransactionDetailCellField;
    fieldType: FormFieldType;
    label: string;
    copyToClipboard?: boolean;
}[] = [
    {
        field: 'uniqueId',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_UNIQUE_ID',
        copyToClipboard: true,
    },
    {
        field: 'transactionDate',
        fieldType: FormFieldType.Date,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_TRANSACTION_DATE',
    },
    {
        field: 'settlementDate',
        fieldType: FormFieldType.Date,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_SETTLEMENT_DATE',
    },
    {
        field: 'from',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_FROM',
    },
    {
        field: 'to',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_TO',
    },
    {
        field: 'statusText',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_STATUS',
    },
    {
        field: 'amount',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_AMOUNT',
    },
    {
        field: 'fromIdentifier',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_FROM_IDENTIFIER',
    },
    {
        field: 'toIdentifier',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_TO_IDENTIFIER',
    },
    {
        field: 'portfolioName',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_PORTFOLIO_NAME',
    },
    {
        field: 'accountName',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_ACCOUNT_NAME',
    },
    {
        field: 'debitAccountIBAN',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_DEBIT_ACCOUNT_IBAN',
    },
    {
        field: 'creditAccountIBAN',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_CREDIT_ACCOUNT_IBAN',
    },
    {
        field: 'endToEndReference',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_END_TO_END_REFERENCE',
    },
    {
        field: 'systemIdentifier',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_SYSTEM_IDENTIFIER',
    },
    {
        field: 'beneficiaryAccountIdentifier',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_BENEFICIARY_ACCOUNT_IDENTIFIER',
    },
    {
        field: 'paymentOrderProductTypeCode',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_PAYMENT_ORDER_PRODUCT_TYPE_CODE',
    },
    {
        field: 'paymentOrderIdentifier',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_PAYMENT_ORDER_IDENTIFIER',
    },
    {
        field: 'netCostOrProceeds',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_NET_COST_OR_PROCEEDS',
    },
    {
        field: 'chargeBearer',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_CHARGE_BEARER',
    },
    {
        field: 'totalCharges',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_TOTAL_CHARGES',
    },
    {
        field: 'debitTotalAmount',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_DEBIT_TOTAL_AMOUNT',
    },
    {
        field: 'accountWithBankBIC',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_ACCOUNT_WITH_BANK_BIC',
    },
    {
        field: 'description',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_DESCRIPTION',
    },
    {
        field: 'accountId',
        fieldType: FormFieldType.Text,
        label: 'COLUMN_PORTFOLIO_TRANSACTION_ACCOUNT_ID',
    },
];
